import React, { useState } from "react";
import { Table, Row, Col, Typography, Button, Space, message } from "antd";
import { removeCertification } from "../../../../../services/vendorProfile.services";
import CertificationModal from "./CertificationModal";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import { CertificationColumns } from "../../../../PQQ/tableColumns";

const { Paragraph } = Typography;

const Certification = (props) => {
  const [editTable, setEditTable] = useState(null);
  const [visible, setVisible] = useState(false);

  const refreshPage = () => {
    props.fetchCertifications(props.vendorId);
  };

  const openModal = (data) => {
    setVisible(true);
    setEditTable(data);
  };

  const removeColumn = (id) => {
    removeCertification({
      id: id,
      vendor_id: props.vendorId,
    })
      .then((response) => {
        refreshPage();
        message.success(response.data.message);
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };

  const columns = [
    ...CertificationColumns,
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ ...record, status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  return (
    <Row>
      <Col span={22} offset={1}>
        <Paragraph>
          List all certifications the applicant firm currently possesses, or has
          any application pending for, any business opportunity program,
          including Minority-Owned Business Enterprise, Women-Owned Business
          Enterprise, Disadvantaged Business Enterprise, Veteran-Owned Business
          Enterprise, and Small Business Enterprise. Attach copies of all
          certifications listed.
        </Paragraph>
        <Button
          onClick={openModal}
          type="secondary"
          style={{
            marginBottom: 16,
          }}
        >
          Add Certification
        </Button>
      </Col>
      <Col span={22} offset={1}>
        <Table
          size="small"
          columns={columns}
          dataSource={props.certificationData}
          pagination={false}
          scroll={{ x: 800 }}
        />
      </Col>
      {visible && (
        <CertificationModal
          setVisible={setVisible}
          title="Add Certification"
          vendorId={props.vendorId}
          editTable={editTable}
          refresh={refreshPage}
        />
      )}
    </Row>
  );
};

export default Certification;
